import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@shadcn-in-nx/ui/input";
import { Search, X } from "lucide-react";
import { Button } from "@shadcn-in-nx/ui/button";

function DatabaseSearch({ value, onChange }) {
    const { t } = useTranslation();

    return (
        <div className="relative w-full sm:w-64">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={t("databases.searchPlaceholder", "Search databases...")}
                className="pl-9 pr-8"
            />
            {value && (
                <Button
                    variant="ghost"
                    size="sm"
                    className="absolute right-1 top-1/2 -translate-y-1/2 h-6 w-6 p-0"
                    onClick={() => onChange("")}
                >
                    <X className="w-3 h-3" />
                </Button>
            )}
        </div>
    );
}

export default DatabaseSearch;
